import type React from 'react';
import { SHIFT_SCOPE, useShortcutScope } from '@/components/shortcuts';

/**
 * Pushed only while the shift dialog is open, suspending the rest of the
 * `seller` scope so no sale-screen shortcut fires underneath it — mirrors
 * `PaymentScope`. A named sibling of `ShiftModal.tsx` rather than a second
 * component in that file (rulebook §5.2).
 */
export const ShiftScope: React.FC = () => {
    useShortcutScope(SHIFT_SCOPE);
    return null;
};
